import EventEmitter from './EventEmitter';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import * as THREE from 'three';

export default class Resources extends EventEmitter {
    constructor(sources) {
        super();

        this.sources = sources;
        this.items = {};
        this.toLoad = this.sources.length;
        this.loaded = 0;

        this.setLoaders();
        this.startLoading();
    }

    setLoaders() {
        this.loaders = {};
        this.loaders.gltfLoader = new GLTFLoader();
        this.loaders.textureLoader = new THREE.TextureLoader();
        this.loaders.cubeTextureLoader = new THREE.CubeTextureLoader();
    }

    startLoading() {
        for(const source of this.sources){
            if(source.type === 'cubeTexture') {
                this.loaders.cubeTextureLoader.load(
                    source.path,
                    (texture) => {
                        this.sourceLoaded(source, texture)
                    }
                )
            }

            if(source.type === 'gltfModel') {
                this.loaders.gltfLoader.load(
                    source.path,
                    (gltf) => {
                        gltf.scene.traverse(n => {
                            if (n.isMesh) {
                                n.material.needsUpdate = true;
                                n.castShadow = true;
                                n.receiveShadow = true;
                                if (n.material.map) n.material.map.anisotropy = 16;
                            }
                        });
                        this.sourceLoaded(source, gltf);
                    },
                    (xhr) => {

                        if ( xhr.lengthComputable ) {
                            document.querySelector('[data-loading-progress]').innerHTML = Math.floor(xhr.loaded / xhr.total * 100) + '';
                        }
                    }
                )
            }

        }
    }

    sourceLoaded(source, file) {
        this.items[source.name] = file;

        this.loaded++;

        if(this.loaded === this.toLoad) {
            this.trigger('ready');
        }
    }
}